import Vue from 'vue';
import Vuex from 'vuex';
import auth from '@/features/auth/store';
import session from '@/services/session';
import search from './search';
import tracking, { trackMutations } from './tracking';

Vue.use(Vuex);

interface IError {
  type: string;
  detail: any;
}

trackMutations('root')({
  ERROR: (error: IError) => error,
} as any);

const soundEnabledKey = 'sound';
const isIOS = !!navigator.platform.match(/iPhone|iPod|iPad/);
const isWebApp = (
  window.matchMedia('(display-mode: standalone)').matches
    || (window.navigator as any).standalone
);

const toggleSound = (state: any, value?: boolean) => {
  // use value provided or toggle
  const result = value === undefined ? !state.enableSound : value;
  state.enableSound = result;
  session.set(soundEnabledKey, result);
};

export default new Vuex.Store({
  modules: {
    search,
    auth: auth({
      trackMutations: trackMutations('auth'),
    }),
  },
  state: {
    enableSound: session.get(soundEnabledKey) === 'true',
    errors: [],
    isIOS,
    isMobile: false,
    isWebApp,
  },
  plugins: [
    // TODO: track mutations
    // tracking(console.log),
  ],
  mutations: {
    ERROR(state: any, error: IError) {
      state.errors = state.errors.concat(error);
      console.error(error);
    },
    IS_MOBILE(state: any, value: boolean) {
      state.isMobile = value;

      // turn sounds off for mobile
      value && toggleSound(state, false);
    },
    TOGGLE_SOUND(state: any, value?: boolean) {
      toggleSound(state, value);
    },
  },
  actions: {
    toggleSound: ({ commit }: any) => {
      commit('TOGGLE_SOUND');
    },
  },
});
